import constants from './constants';

export const initialState = {
  items: [],
  name: '',
  showActions: false,
};

export default function nav(state = initialState, action) {
  switch (action.type) {
    case constants.actions.RECEIVE_NAV:
      return {
        ...state,
        ...action.nav,
      };
    case constants.actions.RECEIVE_NAME:
      return {
        ...state,
        name: action.name,
      };
    case constants.actions.SHOW_ACTIONS:
      return {
        ...state,
        showActions: !state.showActions,
      };
    default:
      return state;
  }
}
